import type {DefaultTheme} from 'styled-components';

// eslint-disable-next-line no-restricted-imports -- Intended
import {path} from 'ramda';

export const getToken = (key: string, theme: DefaultTheme) =>
  path<number>(key.split('.'), theme) ?? '';
